import React from 'react';
import './Header.css';
import { ServiceStatus, StatusCounts } from '../types/Service';

interface HeaderProps {
  overallStatus: ServiceStatus;
  lastUpdated: Date;
  statusCounts: StatusCounts;
  isLoading: boolean;
  onRefresh: () => void;
  currentPage: 'seedpool' | 'stats' | 'history';
  onPageChange: (page: 'seedpool' | 'stats' | 'history') => void;
}

const Header: React.FC<HeaderProps> = ({
  overallStatus,
  lastUpdated,
  statusCounts,
  isLoading,
  onRefresh,
  currentPage,
  onPageChange
}) => {


  const totalServices = Object.values(statusCounts).reduce((sum, count) => sum + (count || 0), 0);

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-main">
          <div className="header-title">
            <div className="page-toggle">
              <button 
                className={`toggle-button ${currentPage === 'seedpool' ? 'active' : ''}`}
                onClick={() => onPageChange('seedpool')}
              >
                Seedpool Status
              </button>
              <button 
                className={`toggle-button ${currentPage === 'stats' ? 'active' : ''}`}
                onClick={() => onPageChange('stats')}
              >
                Stats
              </button>
              <button 
                className={`toggle-button ${currentPage === 'history' ? 'active' : ''}`}
                onClick={() => onPageChange('history')}
              >
                History
              </button>
            </div>
          </div>
          
          <button 
            className="refresh-button"
            onClick={onRefresh}
            disabled={isLoading}
            title="Refresh status"
          >
            <svg 
              className={`refresh-icon ${isLoading ? 'spinning' : ''}`}
              width="20" 
              height="20" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2"
            >
              <polyline points="23 4 23 10 17 10"></polyline>
              <polyline points="1 20 1 14 7 14"></polyline>
              <path d="m3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
            </svg>
          </button>
        </div>

        <div className="header-stats">
          <div className="stat-item">
            <span className="stat-label">Services</span>
            <span className="stat-value">{totalServices}</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Operational</span>
            <span className="stat-value operational">{statusCounts.operational || 0}</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Issues</span>
            <span className="stat-value degraded">{(statusCounts.degraded || 0) + (statusCounts.down || 0)}</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Last Check</span>
            <span className="stat-value">{lastUpdated.toLocaleTimeString()}</span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;




